/**
 * Part Alignment Embed
 * Embeds the external Part Alignment (stock) application served from the
 * ECS upstream inside the Knowledge Centre at /part-alignment.
 */

import React from 'react';
import './PartAlignmentEmbed.css';

const PART_ALIGNMENT_URL = 'https://cnc.rapidfusionfleet.co.uk/';

function PartAlignmentEmbed() {
  return (
    <div className="pa-embed">
      <iframe
        className="pa-embed-frame"
        src={PART_ALIGNMENT_URL}
        title="Part Alignment"
        allow="clipboard-read; clipboard-write; fullscreen"
      />
    </div>
  );
}

export default PartAlignmentEmbed;
